const  frequentQuestion = [
    {
        question: "Do you offer comprehensive electrical services?",
        answer:"Yes! FixOnTime Electricians provide a full spectrum of industrial and commercial electrical services."
    },
    {
        question: "How swift is FixOnTime in emergency cases?",
        answer:"We are only a chat away. During emergencies, you can call or chat with us. We deploy our technicians immediately."
    },
    {
        question: "Are your services affordable?",
        answer:"We guarantee that you'll get premium value from our services. What's more, you save up to 40% on procurement costs when you buy equipment through us! "
    },
    {
        question: "Can I get quick online solutions?",
        answer:"Yes, you can request quotes online, send us an inquiry via email or chat with us on WhatsApp."
    },
]

export {
    frequentQuestion
}